import React from 'react'
import type { OpportunitySignals } from '../services/signalsService'
import { OpportunityPnlBadge } from './OpportunityPnlBadge'

type Props = {
  communityEnabled?: boolean
  summaryContent: React.ReactNode
  signals: OpportunitySignals | null
}

export function OpportunityCommunityPnlRow({
  communityEnabled,
  summaryContent,
  signals,
}: Props) {
  if (!communityEnabled) return null

  return (
    <div className="mt-3 -mx-4 rounded-b-xl bg-[#141415]">
      <div className="h-px w-full bg-[#161616]" />
      <div className="flex items-center px-4 py-2">
        <div className="flex-[0.8] min-w-0 text-xs text-foreground/80">
          {summaryContent}
        </div>
        <div className="flex-[0.2] flex justify-end">
          <OpportunityPnlBadge signals={signals} />
        </div>
      </div>
    </div>
  )
}
